import { ReactNode } from "react";
import { cn } from "../../../../utils/class-names";

interface NavBarProps {
  className?: string;
  children?: ReactNode;
}

export function NavBar({ className, children }: NavBarProps): JSX.Element {
  return (
    <div className={cn("flex items-center justify-between h-11", className)}>
      {children}
    </div>
  );
}
